import React from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import SvgIcon from '@mui/material/SvgIcon'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Stack } from '@mui/material'

// All cards share the same dark navy look; the per-card `color` prop is kept
// as the icon accent so links remain distinguishable at a glance
const QuickActionCard = ({
  url,
  icon,
  label,
  color = '#46D7E1',
  onClick,
  largeSize,
}) => {
  const navigate = useNavigate()
  return (
    <Grid item xs={4} lg={largeSize ?? 6}>
      <Box
        display="flex"
        alignItems="center"
        height="100%"
        onClick={onClick ? onClick : url ? () => navigate(url) : () => {}}
        sx={{
          background:
            'radial-gradient(circle at top left, rgba(35,154,164,0.18), transparent 45%), linear-gradient(135deg, #1A2230 0%, #242F40 60%, #2C3B52 100%)',
          borderRadius: 2.5,
          border: '1px solid rgba(255,255,255,0.07)',
          boxShadow: '0 4px 12px rgba(15,23,42,0.22)',
          cursor: 'pointer',
          transition: 'transform 0.15s ease, box-shadow 0.15s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 10px 22px rgba(15,23,42,0.32)',
            '& .quick-action-icon': {
              backgroundColor: 'rgba(255,255,255,0.16)',
            },
          },
        }}
      >
        <Stack
          height="100%"
          width="100%"
          alignItems="center"
          justifyContent={{ xs: 'center', lg: 'flex-start' }}
          direction={{ xs: 'column', lg: 'row' }}
          gap={{ xs: 0.75, lg: 1.25 }}
          padding={1.25}
        >
          <Box
            className="quick-action-icon"
            sx={{
              width: 34,
              height: 34,
              borderRadius: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              backgroundColor: 'rgba(255,255,255,0.10)',
              transition: 'background-color 0.15s ease',
            }}
          >
            <SvgIcon
              component={icon}
              sx={{
                width: '1.2rem',
                height: '1.2rem',
                color: color,
              }}
            />
          </Box>
          <Typography
            fontSize="0.9rem"
            fontWeight={600}
            color="#ffffff"
            textAlign={{ xs: 'center', lg: 'left' }}
            sx={{ wordWrap: 'break-word' }}
          >
            {label}
          </Typography>
        </Stack>
      </Box>
    </Grid>
  )
}

export default QuickActionCard
